import { render, staticRenderFns } from "./ManutencaoNotaFiscalForm.vue?vue&type=template&id=53b64921"
import script from "./ManutencaoNotaFiscalForm.vue?vue&type=script&lang=js"
export * from "./ManutencaoNotaFiscalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports